export default {
	title: 'Rappel',
	rappel: 'Conformément aux CGU, toutes les pièces transmises à l\'appui du questionnaire seront portées à la connaissance de votre salarié ou de votre employeur.',
	rappelSalarie: 'Il est rappelé qu\'aucune pièce à caractère médical ne doit être transmise via ce téléservice. A défaut, le secret médical sera considéré comme levé et la responsabilité de la Caisse Nationale d\'Assurance Maladie ne saurait être engagée conformément aux CGU.',
	btnAnnuler: 'Annuler',
	btnConfirm: 'Valider'
};
